/**
 * Разбивает строку с домом на номер дома и корпуса
 * @param {string} [house='2б']
 * @return {object}
 */
export const dissectHouse = house => {
    house = house ?? '';

    const build = {
        house_num: null,
        house_build: null,
    };
    const arr = house.split('/');

    if (arr.length === 2) {
        build.house_num = arr[0];
        build.house_build = arr[1];
    } else {
        build.house_num = parseInt(house);
        build.house_build = house.replace(new RegExp(`${build.house_num}|[\\-\s]`, 'gi'), '');
    }

    // TODO: временный фикс для биллинга, если нет значения то хотя бы пробел. В конце значения пробел не мешает
    build.house_build += ' ';

    return build;
};

/**
 * Форматируем объект для value в react-select
 * @param {object} object входной объект
 * @param {string} [valueKey='value'] ключь значения в входном объекте
 * @param {string} [labelKey='label'] ключь лейбла в входном объекте
 * @return {object}
 */
export const toSelectOption = ({ object, valueKey = 'value', labelKey = 'label' }) => ({
    value: object[valueKey],
    label: object[labelKey],
});
export const toSelectOptionWithProvider = ({ object, valueKey = 'value', labelKey = 'label' }) => ({
    value: { valueKey: object[valueKey], providerId: object['provider_id'] },
    label: object[labelKey],
});

/**
 * Форматируем массив объектов для options в react-select
 * @param {array} array входной массив объектов
 * @param {object} keys объект ключей для метода toSelectOption
 * @return {array}
 */
export const toSelectOptions = ({ array, keys }) => array.map(object => toSelectOption({
    object,
    ...keys,
}));
export const toSelectOptionsWithProvider = ({ array, keys }) => array.map(object => toSelectOptionWithProvider({
    object,
    ...keys,
}));


/**
 * фильтруем уникальные значения массива
 * @param arr
 * @returns {string[]}
 */
export const uniqueArrItems = (arr) => {
    const obj = {};

    for (var i = 0; i < arr.length; i++) {
        const str = arr[i];
        obj[str] = true; // запомнить строку в виде свойства объекта
    }

    return Object.keys(obj); // или собрать ключи перебором для IE8-
};

/**
 * форматирование даты для вывода 2019-06-07 => 07.06.2019
 * @param date
 * @returns {*}
 */
export const showFormatDate = (date) => {
    return date.split('-').reverse().join('.');
};
